var QUICK_BUY = {
	addListeners: function() {
		console.log("Product Pagelisteners have been added");
		$('.product-size-swatch').click(function(event) {
			if ( !$(this).hasClass('selected') ) {
				$('.product-size-swatch').removeClass('selected')
				$(this).addClass('selected');
			}
			var variantID = '';
			var newVariantOption = '';
			var form = $(this).closest('form');
			var selectedSize = $(this).attr('id');
			var selectedColor = $(this).closest('form').find('.product-color-swatch.selected').attr('id');

			$(this).closest('form').find('.productSelect option:selected').removeAttr('selected');

			var hiddenSizeSelector = $(this).closest('form').find('#productSelect-option-1');
			var variantSelector = $(this).closest('form').find('select.productSelect');

			var hiddenSizeMobileSelector = $(this).closest('form').find('#productSelectMobile-option-1');
			var variantMobileSelector = $(this).closest('form').find('select.productSelectMobile');

			hiddenSizeSelector.val(selectedSize).attr('selected', 'selected').change();
			hiddenSizeMobileSelector.val(selectedSize).attr('selected', 'selected').change();

			$(this).closest('form').find('select option').each(function(){
				if (selectedSize && selectedColor) {
					if ( ($(this).data('size') == selectedSize) && ( $(this).data('color') == selectedColor ) ) {
						variantID = $(this).val();
						newVariantOption = $(this);
					}
				} else {
					if ( ($(this).data('size') == selectedSize) ) {
						variantID = $(this).val();
						newVariantOption = $(this);
					}
				}
			});

			var variantInventory = $(newVariantOption).attr('data-inventory');

			if ( (variantInventory <= 0) ){
				QUICK_BUY.disableQuickBuyButton(form)
			} else {
				QUICK_BUY.enableQuickBuyButton(form);
			}

			if ( $(this).parent().parent().parent().hasClass('quick-add-to-cart-form') ){
				QUICK_BUY.setVariantSelector(variantSelector, selectedSize, selectedColor);
				QUICK_BUY.setVariantSelector(variantMobileSelector, selectedSize, selectedColor);
			} else {
    		PRODUCT.setVariantValues(selectedColor, selectedSize);
			}
		});

		$('.product-color-swatch').click(function(event) {
			if ( !$(this).hasClass('selected') ) {
				$('.product-color-swatch').removeClass('selected')
				$(this).addClass('selected');
			}
			var selectedColor = $(this).attr('id');
			var form = $(this).closest('form');

			$(this).closest('form').find('.productSelect option:selected').removeAttr('selected');

			var hiddenColorSelector = $(this).closest('form').find('#productSelect-option-0');
			var variantSelector = $(this).closest('form').find('select.productSelect');
			var hiddenColorMobileSelector = $(this).closest('form').find('#productSelectMobile-option-0');
			var variantMobileSelector = $(this).closest('form').find('select.productSelectMobile');
			var selectedSize = $(this).closest('form').find('.product-size-swatch.selected').attr('id') || "S";

			hiddenColorSelector.val(selectedColor).attr('selected', 'selected').change();
			hiddenColorMobileSelector.val(selectedColor).attr('selected', 'selected').change();


			if ( $(this).parent().parent().parent().hasClass('quick-add-to-cart-form') ){
				var variantID = '';
				var newVariantOption = '';

				$(this).closest('form').find('select option').each(function(){
					if (selectedSize && selectedColor) {
						if ( ($(this).data('size') == selectedSize) && ( $(this).data('color') == selectedColor ) ) {
							variantID = $(this).val();
							newVariantOption = $(this);
						}
					} else {
						if ( ($(this).data('size') == selectedSize) ) {
							variantID = $(this).val();
							newVariantOption = $(this);
						}
					}
				});

				var newVariantImageUrlExtension = $(newVariantOption).attr('data-image').split('/')[1];
				var quickBuyPrimaryImage = $(this).closest('.product__grid-item--outer-wrapper').find('img.product__image')[0];
				var variantInventory = $(newVariantOption).attr('data-inventory');

				if ( (variantInventory <= 0) ){
					QUICK_BUY.disableQuickBuyButton(form)
				} else {
					QUICK_BUY.enableQuickBuyButton(form);
				}

				QUICK_BUY.swapQuickBuyPrimaryImage( variantID, newVariantImageUrlExtension, quickBuyPrimaryImage );
			} else {
	    	swapThumbs(selectedColor);
			}


			if ( $(this).parent().parent().parent().hasClass('quick-add-to-cart-form') ){
				QUICK_BUY.setVariantSelector(variantSelector, selectedSize, selectedColor);
				QUICK_BUY.setVariantSelector(variantMobileSelector, selectedSize, selectedColor);
			} else {
    		PRODUCT.setVariantValues(selectedColor, selectedSize);
			}

		});

		$('.quick-add-to-cart-form').each(function(){
			var variantID = '';
			var newVariantOption = '';
			var form = $(this);
			var selectedColor = $(this).find('.product-color-swatch.selected').attr('id');
			var selectedSize = $(this).find('.product-size-swatch.selected').attr('id');

			$(this).find('select option').each(function(){
				if (selectedSize && selectedColor) {
					if ( ($(this).data('size') == selectedSize) && ( $(this).data('color') == selectedColor ) ) {
						variantID = $(this).val();
						newVariantOption = $(this);
					}
				} else {
					if ( ($(this).data('size') == selectedSize) ) {
						variantID = $(this).val();
						newVariantOption = $(this);
					}
				}
			});

			var variantInventory = $(newVariantOption).attr('data-inventory');

			if ( (variantInventory <= 0) ){
				QUICK_BUY.disableQuickBuyButton(form);
			} else {
				QUICK_BUY.enableQuickBuyButton(form);
			}
		});

		if ( $(window).width() > 768 ) {
			$('.quick-add-to-cart').click(function(event) {
	    	event.preventDefault();
	      var form = $(this).closest('form.quick-add-to-cart-form');
	      var data = form.serialize();
	      ga('send', 'event', 'Cart', 'Add', 'Add Products to Cart');
	      QUICK_BUY.addToCart(data, form);
	  	});
		}
		if ( $(window).width() > 768 ) {
	  	$('.collection--product__wrapper').hover(function( ) {
	  		console.log("on");
	  		QUICK_BUY.showOverLay( $(this) );
	  	}, function() {
	  		console.log("off");
	  		QUICK_BUY.hideOverLay( $(this) );

	  	});
  	}
	},
	swapQuickBuyPrimaryImage: function( variantID, newVariantImageUrlExtension, quickBuyPrimaryImage ) {
		var oldImageSrc = $(quickBuyPrimaryImage).attr('src');
		var newVariantImageUrl = oldImageSrc.split('products/')[0] + "products/" + newVariantImageUrlExtension + "?v=" + variantID
		// console.log(newVariantImageUrl)
		newVariantImageUrl = newVariantImageUrl.replace('.jpg', '_large.jpg');
		$(quickBuyPrimaryImage).attr('src', newVariantImageUrl)
	},
	onLoad: function() {
		console.log("Product Page JS loaded");
	},
	addToCart: function(data, form) {
		$.ajax({
			url: '/cart/add.js',
			type: 'POST',
			data: data,
			dataType: 'json'
		})
		.complete(function(data) {
			$('.error-message').empty();
			if ( data.success().status == 200 ) {
				QUICK_BUY.cartSuccess(data.responseJSON)
			} else {
				if ( data.responseJSON.description == "Required parameter missing or invalid: id" ){
					// $('.error-message').empty();
					
						var message = "Sorry, the item you selected is no longer in stock.";
						// QUICK_BUY.cartError(message)
					
				} else if ( data.responseJSON.message == "Cart Error" ){
					// $('.error-message').empty();
					
						var message = "Sorry, the item you selected is now sold out.";
						// QUICK_BUY.cartError(message);
					
				}
			}
			if (message.length > 0) {
				QUICK_BUY.cartError(message, form);
			}
		})
	},
	cartSuccess: function( product ){
		// change to this button text!
		var form = $('form#'+product.product_id.toString());
		var submitButtonText = form.find($('.quick-add-to-cart-text'));
		var rolloverSpan = form.find($('span.rollover.product-form'));
		rolloverSpan.toggleClass('red-rollover').toggleClass('teal-rollover');
		$(submitButtonText).text('ITEM ADDED!').addClass('teal');
		QUICK_BUY.buildCartPopIn( product );
		setTimeout( function( ) { QUICK_BUY.resetButtonText( product) }, 3000);
	},
	cartError: function( message, form ){
		var activeForm = form;
		var errorMessage = message;
		$(activeForm).find('.error-message').text(message).fadeIn(300);
		setTimeout(function(){
			$(activeForm).find('.error-message').fadeOut(300);
			setTimeout(function(){
				$(activeForm).find('.error-message').text('');
			}, 300);
		}, 1500);
	},
	resetButtonText: function( product ) {
		var form = $('form#'+product.product_id.toString());
		var submitButtonText = form.find($('.quick-add-to-cart-text'));
		var rolloverSpan = form.find($('span.rollover.product-form'));
		rolloverSpan.toggleClass('red-rollover').toggleClass('teal-rollover');
		$(submitButtonText).text("ADD TO CART").removeClass('teal');
	},
	buildCartPopIn: function( product ) {
		$.ajax({
			url: '/cart.js',
			type: 'GET',
			dataType: 'json',
		})
		.complete(function( data  ) {

			var cartCount = (data.responseJSON.item_count);

			QUICK_BUY.updateCartCount(cartCount);

			var lastItem = data.responseJSON.items[0];
			var imgSrc = lastItem.image;
			var title = lastItem.product_title;
			var type = lastItem.product_type || "n/a";
			var size = lastItem.variant_options[0];
			var color = lastItem.variant_options[1];
			var totalPrice = data.responseJSON.total_price;
			var imgElement = $('.cart__pop-in--image-wrapper');
			imgElement.append( $('<img>').attr('src', imgSrc ) );
			var titleElement = $('p.cart__pop-in.title')
			titleElement.text(title);
			var typeElement = $('p.cart__pop-in.type');
			if ( type !== "n/a") {
				typeElement.text(type);
			}
			var sizeElement = $('p.cart__pop-in.size');
			sizeElement.text(color);
			var colorElement = $('p.cart__pop-in.color');
			colorElement.text(size);
			var promoElement = $('p.cart__pop-in.promo')

			var totalDiff = (10000 - totalPrice).toString()

			/*if ( totalPrice < 10000 ) {
				promoElement.text("Only $" + ( totalDiff.slice(0, -2) ) + " left until FREE SHIPPING!")
			} else {
				promoElement.text("You have earned FREE SHIPPING!")
			}*/
			$(".cart__pop-in--wrapper").slideDown('300', function() {
				setTimeout( function( ) { QUICK_BUY.hideCartPopIn(imgElement, titleElement, typeElement, sizeElement, colorElement, promoElement) }, 4500);
			});

		})
	},
	updateCartCount: function(cartCount){
		var cartCountElement = $('.cart__count');
		if ( cartCount == 0 ) {
			cartCountElement.addClass('hidden').text( (cartCount).toString() );
		} else {
			cartCountElement.removeClass('hidden').text( (cartCount).toString() );
		}
	},
	hideCartPopIn: function(imgElement, titleElement, typeElement, sizeElement, colorElement, promoElement){
		$(".cart__pop-in--wrapper").slideUp();
		imgElement.find('img').attr('src', '');
		titleElement.empty();
		typeElement.empty();
		sizeElement.empty();
		colorElement.empty();
		promoElement.empty();
		console.log("close cart")
	},
	setVariantSelector: function(selector, size, color) {
		if ( color !== undefined && size !== undefined ){
			var selectedVariantOption = selector.find($("option[data-color=" + color + "][data-size=" + size + "]"));
		} else if (color !== undefined && size === undefined) {
			var selectedVariantOption = selector.find($("option[data-color=" + color + "]"));
		} else if (color === undefined && size !== undefined) {
			var selectedVariantOption = selector.find($("option[data-size=" + size + "]"));
		} else {
			return false
		}
		selectedVariantOption.attr('selected', 'selected').change();
	},
	showOverLay: function(element) {
		var overLay = element.find($('.product--overlay__wrapper'));
		$(overLay).animate({opacity: 1}, 400);
		overLay.addClass('revealed');
	},
	hideOverLay: function(element) {
		var overLay = element.find($('.product--overlay__wrapper'));
		$(overLay).animate({opacity: 0}, 400);
		overLay.removeClass('revealed');
	},
	// need to properly disable add to cart button for quick buy
	disableQuickBuyButton: function(form) {
		var button = $(form).find('button');
		$(button).addClass('disabled');
	},
	enableQuickBuyButton: function(form) {
		var button = $(form).find('button');
		$(button).removeClass('disabled');
	}
}
$(document).ready( function(){
	QUICK_BUY.onLoad();
	QUICK_BUY.addListeners();
});
